import enumService from '../shared/enumService.js';

class CoverageTranslator {
  translatePolicyCoverages (policyCoverageResponse) {
    var translated = {
      coverages: [],
      locationCoverages: [],
      lineOfBusinessCoverages: []
    };

    if (policyCoverageResponse === null) return translated;

    if ((policyCoverageResponse.A || null) !== null) {
      translated.coverages = policyCoverageResponse.A.map(x => this.translateCoverage(x));
    }

    if ((policyCoverageResponse.B || null) !== null) {
      translated.locationCoverages = policyCoverageResponse.B.map(x => this.translateLocationCoverages(x));
    }

    if ((policyCoverageResponse.C || null) !== null) {
      translated.lineOfBusinessCoverages = policyCoverageResponse.C.map(x => this.translateLineOfBusinessCoverages(x));
    }

    return translated;
  }

  translateLineOfBusinessCoverages (lobCoverage) {
    var result = {
      coverages: [],
      locationCoverages: [],
      code: lobCoverage.C
    };

    if ((lobCoverage.A || null) !== null) {
      result.coverages = lobCoverage.A.map(x => this.translateCoverage(x));
    }

    if ((lobCoverage.B || null) !== null) {
      result.locationCoverages = lobCoverage.B.map(x => this.translateLocationCoverages(x));
    }

    return result;
  }

  translateLocationCoverages (locCoverage) {
    var result = {
      coverages: [],
      buildingCoverages: [],
      name: locCoverage.B,
      number: locCoverage.C
    };

    if ((locCoverage.A || null) !== null) {
      result.coverages = locCoverage.A.map(x => this.translateCoverage(x));
    }

    if ((locCoverage.D || null) !== null) {
      result.buildingCoverages = locCoverage.D.map(x => this.translateLocationCoverages(x));
    }

    return result;
  }

  translateHomeCoverages (homeCoverages) {
    var result = {
      coverages: [],
      deductibles: [],
      endorsementTotalPremium: homeCoverages.C,
      scheduledPropertyTotalPremium: homeCoverages.D,
      creditsAndSurcharges: [],
      totalPremium: homeCoverages.C + homeCoverages.D
    };

    if ((homeCoverages.A || null) !== null) {
      result.coverages = homeCoverages.A.map(x => {
        result.totalPremium += x.F;
        return this.translateCoverage(x);
      });
    }

    if ((homeCoverages.B || null) !== null) {
      result.deductibles = homeCoverages.B.map(x => {
        result.totalPremium += x.F;
        return this.translateCoverage(x);
      });
    }

    if ((homeCoverages.E || null) !== null) {
      result.creditsAndSurcharges = homeCoverages.E.map(x => {
        result.totalPremium += x.F;
        return this.translateCoverage(x);
      });
    }

    return result;
  }

  translateHomeScheduledProperty (coverages) {
    var result = {
      schedules: [],
      totalPremium: 0
    };

    result.schedules = coverages.map(x => {
      result.totalPremium += x.F;
      return this.translateCoverage(x);
    });

    return result;
  }

  translateHomeEndorsements (endorsements) {
    var result = {
      earthquake: {},
      watercrafts: [],
      miscellaneous: [],
      totalPremium: 0
    };

    if ((endorsements.A || null) !== null) {
      var earthquake = this.translateCoverage(endorsements.A);
      earthquake.includeMasonryVeneer = endorsements.A.H;
      earthquake.coverage = endorsements.A.I;
      result.totalPremium += earthquake.premium;
      result.earthquake = earthquake;
    }

    if ((endorsements.B || null) !== null) {
      result.watercrafts = endorsements.B.map(x => {
        var wc = this.translateCoverage(x);
        wc.boatPropulsionType = enumService.boatPropulsionType[x.H];
        wc.speed = x.I;
        wc.length = x.J;
        wc.horsePower = x.K;
        result.totalPremium += wc.premium;
        return wc;
      });
    }

    if ((endorsements.C || null) !== null) {
      result.miscellaneous = endorsements.C.map(x => {
        result.totalPremium += x.F;
        return this.translateCoverage(x);
      });
    }

    return result;
  }

  translateCoverage (coverage) {
    var opts = null;
    if ((coverage.O || null) !== null) {
      opts = coverage.O.map(x => {
        return this.translateCoverageOption(x);
      });
    }

    return {
      name: coverage.A,
      description: coverage.B,
      displayOrder: coverage.C,
      limits: coverage.D,
      deductibles: coverage.E,
      premium: coverage.F,
      code: coverage.G,
      options: opts
    };
  }

  translateCoverageOption (option) {
    return {
      number: option.A,
      code: option.B,
      description: option.C
    };
  }
}

var x = new CoverageTranslator();
export default x;
